module.exports = __webpack_public_path__ + "img/c.421ebace.jpg";